import { Injectable } from '@angular/core';
import { BaseService } from '../api.service';
import { FormGroupDirective } from '@angular/forms';
@Injectable({
  providedIn: 'root',
})
export class Config extends BaseService {
  GetDefaultFilter(){
    return this.post(`api/emg/Group/GetDefaultFilter`, [])
  }

  getPushSession() {
    return this.get(
      `api/${this.currentUser.domain}/PushOrderSession/inprocess`
    );
  }

  sortLayout(a, b) {
    if (a.index > b.index) {
      return 1;
    } else if (a.index < b.index) {
      return -1;
    } else {
      return 0;
    }
  }

  sortTag(a, b) {
    if (a.value.toLowerCase() > b.value.toLowerCase()) {
      return 1;
    } else if (a.value.toLowerCase() < b.value.toLowerCase()) {
      return -1;
    } else {
      return 0;
    }
  }

  getLayout(domain, idGroup) {
    return this.get(`api/${domain}/LayoutConfig/bygroup`, {
      idGroup: idGroup,
    });
  }

  getLevel(domain, idGroup) {
    this.getCompanySetting(domain).subscribe((res) => {
      var data = this.GetDataFromResult(res);
      localStorage.setItem(`companySetting`, JSON.stringify(data));
      this.checkLoad();
    });

    // this.get(`api/${domain}/Level/bystatus`, { status: 1 }).subscribe((res) => {
    //   let level: any = res;
    //   localStorage.setItem('level', JSON.stringify(res));
    //   this.getLayout(domain, idGroup).subscribe((response: any) => {
    //     //Chia layout theo từng level

    //     level.map((item) => {
    //       //Danh sách layout ở mid theo level
    //       let layoutMidFilter = response.filter(
    //         (layout) =>
    //           layout.groupId &&
    //           layout.levelId == item.id &&
    //           layout.layoutCode === '1'
    //       );

    //       let layoutMid = layoutMidFilter.sort((a, b) => this.sortLayout(a, b));

    //       localStorage.setItem(
    //         `layoutMid${item.code}`,
    //         JSON.stringify(layoutMid)
    //       );

    //       //Danh sách layout ở right theo level
    //       let layoutRightFilter = response.filter(
    //         (layout) =>
    //           layout.groupId &&
    //           layout.levelId == item.id &&
    //           layout.layoutCode === '2'
    //       );
    //       let layoutRight = layoutRightFilter.sort((a, b) =>
    //         this.sortLayout(a, b)
    //       );

    //       localStorage.setItem(
    //         `layoutRight${item.code}`,
    //         JSON.stringify(layoutRight)
    //       );

    //       //Layout mặc định ở giữa
    //       let layoutMidDefault = response.filter(
    //         (layout) => !layout.groupId && layout.layoutCode === '1'
    //       );
    //       let layoutMidDefaultSort = layoutMidDefault.sort((a, b) =>
    //         this.sortLayout(a, b)
    //       );
    //       localStorage.setItem(
    //         `layoutMidDefault`,
    //         JSON.stringify(layoutMidDefaultSort)
    //       );

    //       //Layout mặc định bên phải
    //       let layoutRightDefault = response.filter(
    //         (layout) => !layout.groupId && layout.layoutCode === '2'
    //       );
    //       let layoutRightDefaultSort = layoutRightDefault.sort((a, b) =>
    //         this.sortLayout(a, b)
    //       );
    //       localStorage.setItem(
    //         `layoutRightDefault`,
    //         JSON.stringify(layoutRightDefaultSort)
    //       );
    //     });
    //     this.getCompanySetting(domain).subscribe((res) => {
    //       var data = this.GetDataFromResult(res);
    //       localStorage.setItem(`companySetting`, JSON.stringify(data));
    //       this.getTag(domain).subscribe((res: any) => {
    //         let tagSort = res.sort((a, b) => this.sortTag(a, b));
    //         localStorage.setItem(`tags`, JSON.stringify(tagSort));

    //      this.checkLoad();
    //       });
    //     });
    //   });
    // });
  }

  GetDataFromResult(arr) {
    var result = {};
    for (let index = 0; index < arr.length; index++) {
      const element = arr[index];
      if (element.value == 'true') {
        result[element.key] = true;
      } else if (element.value == 'false') {
        result[element.key] = false;
      } else result[element.key] = element.value;
    }
    return result;
  }

  getTag(domain) {
    return this.get(`api/${domain}/OrderTag`);
  }

  getProduct(domain, search, page, pageSize) {
    return this.get(`api/${domain}/Product/active`, {
      search: search,
      page: page,
      pageSize: pageSize,
    });
  }

  getDictionaryType(type) {
    return this.get(`api/DictionaryType/${type}/children`);
  }

  getUserDown(domain, id) {
    return this.get(`api/user/${id}/children`, {
      domain,
    });
  }

  getDeliveryPartner(domain) {
    return this.get(`api/${domain}/Delivery`);
  }

  getDeliveryPartnerByType(domain, deliveryType) {
    return this.get(`api/${domain}/Delivery/bytype`, {
      deliveryType,
    });
  }

  getProvince(domain, page, pageSize, name) {
    return this.get('api/Province/search', {
      page: page,
      pageSize: pageSize,
      name: name,
      domain: domain,
    });
  }

  getProvince_v2(domain) {
    return this.get('api/Province/GetProvince_v2', {
      domain: domain,
    });
  }

  getProvinceViaDelivery(idDelivery) {
    return this.get('api/Province/GetProvinceViaDelivery', {
      idDelivery: idDelivery,
    });
  }

  getChildrenProvince(idProvince) {
    return this.get(`api/Province/${idProvince}/children`);
  }

  getChildrenProvince_v2(idProvince) {
    return this.get(`api/Province/${idProvince}/children_v2`);
  }

  getChildrenDistrict(id) {
    return this.get(`api/District/${id}/children`);
  }

  getChildrenDistrict_v2(id) {
    return this.get(`api/District/${id}/children_v2`);
  }

  getStock(domain, idDelivery) {
    return this.get(`api/${domain}/Stock/bydelivery`, {
      idDelivery,
    });
  }

  getMenu(domain, idGroup) {
    return this.post<any[]>(`api/${domain}/Group/GetMenuByGroup`, [
      {
        name: "groupdId",
        value: idGroup
      },
      {
        name: "domain",
        value: domain
      }
    ]).toPromise();
  }

  getCompanySetting(domain) {
    return this.get(`api/Company/getCompanySetting/${domain}`);
  }
  getSuggestAddress(domain, address) {
    return this.get(`api/${domain}/Customer/getsuggestaddress_v2`, {
      address,
    });
  }
}
